module.exports = ".main-page-container {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    min-width: 230px;\r\n}\r\n.main-page {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    overflow: auto;\r\n}\r\n.main-page-background {\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background-image: url('./assets/map_background.jpg');\r\n    background-color: rgb(20, 40, 60);\r\n    background-position: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./App/Components/main-page.component.css
// module id = 569
// module chunks = 1